// src/components/Footer.js
import React from 'react';

const footerStyle = {
  backgroundColor: '#f8f8f8',
  padding: '10px',
  textAlign: 'center',
  borderTop: '1px solid #ddd',
  marginTop: '20px'
};

const Footer = () => {
  return (
    <footer style={footerStyle}>
      <p>&copy; {new Date().getFullYear()} Chemical Tracker. All rights reserved.</p>
    </footer>
  );
};

export default Footer;